/* eslint-disable react/react-in-jsx-scope */
import Button from '../../components/bootstrap/Button';
import Spinner from '../../components/bootstrap/Spinner';

const TableSpinner = () => {
	return (
		<Button color='primary' isLight>
			<Spinner isSmall inButton isGrow />
			Fetching...
		</Button>
	);
};

export default TableSpinner;
